'use strict';

angular.module('shiftTraderApp')
  .service('UserPermissionsService', ['storage', '$rootScope', 'Session', '$log', '$q', 'UserPermissions', function(storage, $rootScope, Session, $log, $q, UserPermissions) {
    var that = this;

    var records = [];
    var permissionsByOrg = {};
    var queuedChecks = [];
    var queuedRecordRequests = [];
    var requestSucceeded = null;
    var requestInProgress = false;

    this.flush = function() {
      records = [];
      permissionsByOrg = {};
      queuedChecks = [];
      queuedRecordRequests = [];
      requestSucceeded = null;
      requestInProgress = false;
    };

    $rootScope.$on('flushCaches', function() {
      that.flush();
    });

    that.forceDataRefresh = function() {
      var userId = Session.me && Session.me.id;
      getPermissionsFromServer(userId);
    };

    function processQueue() {
      while(queuedChecks.length > 0) {
        var check = queuedChecks.shift();
        check.deferred.resolve(that.hasPermissionInOrg(check.permission, check.orgId));
      }

      while (queuedRecordRequests.length > 0) {
        var req = queuedRecordRequests.shift();

        var record = _.find(records, {organization_id: req.orgId});

        if (record) {
          req.deferred.resolve(record);
        } else {
          req.deferred.reject();
        }
      }
    }

    function getPermissionsFromServer(userId) {
      UserPermissions.getByUserId(userId)
        .then(function(permArray) {
          records = permArray;

          var temp = {};

          _.each(permArray, function(permEntry) {
            if (_.isNull(permEntry.permission_set_id)) {
              temp[permEntry.organization_id] = permEntry.permissions;
            } else {
              temp[permEntry.organization_id] = permEntry.permission_set.permissions;
            }
          });

          permissionsByOrg = temp;

          processQueue();

          requestInProgress = false;
          requestSucceeded = true;
        }, function(response) {
          requestSucceeded = false;
        });
    }

    function startOrWaitOnRequest() {
      var userId = Session.me && Session.me.id;

      if ((queuedChecks.length > 0 || queuedRecordRequests.length > 0) && !requestInProgress && !!userId) {
        requestInProgress = true;
        getPermissionsFromServer(userId);
      }
    }

    function orgRepresented(orgId) {
      return _.has(permissionsByOrg, orgId);
    }

    function checkOnPermission(permission, orgId, deferred) {
      if (orgRepresented(orgId) || requestSucceeded) {
        //console.log('resolving this check immediately', permission);
        deferred.resolve(that.hasPermissionInOrg(permission, orgId));
      } else {
        //console.log('pushed it onto the queue');
        queuedChecks.push({
          permission: permission,
          orgId: orgId,
          deferred: deferred
        });

        startOrWaitOnRequest();
      }
    }

    function checkOnRecord(orgId, deferred) {
      if (orgRepresented(orgId) || requestSucceeded) {
        var record = _.find(records, {organization_id: orgId});
        if (record) {
          deferred.resolve(record);
        } else {
          deferred.reject();
        }
      } else {
        //console.log('pushed it onto the queue');
        queuedRecordRequests.push({
          orgId: orgId,
          deferred: deferred
        });

        startOrWaitOnRequest();
      }
    }

    this.can = function(permission, orgId) {
      if (_.isUndefined(orgId)) {
        throw 'Permission check org undefined';
      } else if (orgId === 'current') {
        orgId = Session.getCurrentOrgId();
      }

      var deferred = $q.defer();

      checkOnPermission(permission, orgId, deferred);
      return deferred.promise;
    };

    this.hasPermissionInOrg = function(permission, orgId) {
      if (orgRepresented(orgId)) {
        return _.contains(permissionsByOrg[orgId], permission);
      } else {
        return false;
      }
    };

    this.getCanDict = function(permissionNameArray, orgId) {
      if (_.isUndefined(orgId)) {
        throw 'Permission check org undefined';
      } else if (orgId === 'current') {
        orgId = Session.getCurrentOrgId();
      }

      var deferred = $q.defer();

      // TODO: may want to consider optimizing this to use 1 resolve instead of N resolves

      $q.all(_.map(permissionNameArray, function(permission) {
        return that.can(permission, orgId);
      }))
        .then(function(results) {
          var dikt = {};
          _.each(permissionNameArray, function(perm, idx) {
            dikt[perm] = results[idx];
          });

          deferred.resolve(dikt);
        });

      return deferred.promise;
    };

    this.getNameOfCurrentRole = function(orgId) {
      if (_.isUndefined(orgId)) {
        throw 'Permission check org undefined';
      } else if (orgId === 'current') {
        orgId = Session.getCurrentOrgId();
      }

      var internalDeferred = $q.defer();
      var externalDeferred = $q.defer();

      checkOnRecord(orgId, internalDeferred);

      internalDeferred.promise.then(function(record) {
        externalDeferred.resolve(record.permission_set_id ? record.permission_set.name : record.role);
      }, function() {
        externalDeferred.reject();
      });

      return externalDeferred.promise;
    };

  }]);
